import script from "./EditOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./EditOffer.vue?vue&type=script&setup=true&lang=js"

import "./EditOffer.vue?vue&type=style&index=0&id=a448d87a&lang=css"

const __exports__ = script;

export default __exports__